import React, { FC } from 'react';
import { DatePicker } from '@material-ui/pickers';
import { DatePickerProps } from '@material-ui/pickers/DatePicker/DatePicker';

const CustomDatePicker: FC<DatePickerProps> = (props) => {
  return (
    <DatePicker
      margin="normal"
      format="dd/MM/yyyy"
      emptyLabel="--//--"
      InputProps={{
        disableUnderline: true,
      }}
      {...props}
    />
  );
};

export default CustomDatePicker;
